import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div
      style={{
        textAlign: 'center',
        marginTop: '20px',
        position: 'fixed',
        bottom: '20px',
        padding: '20px',
        borderRadius: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: '#000000',
        color: '#FFF',
      }}
    >
      <p className="text-sm mb-2 md:mb-0">
        {t('cookieConsent')}{' '}
        <Link to="/privacy" className="underline">
          Privacy Policy
        </Link>
        .
      </p>
      <div>
        <button className="btn btn-primary mx-2" onClick={handleAccept}>
          {t('accept')}
        </button>
        <button className="btn btn-secondary mx-2" onClick={handleDecline}>
          {t('decline')}
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
